import { z, ZodSchema } from "zod";
import { useMutation } from "@tanstack/react-query";
import { formatFirebaseError } from "@shared/services/api/formatFirebaseError";
import { confirmPasswordReset } from "../utils/confirmPasswordReset";

type Args = {
  onSuccess?: (data: any) => void;
  schema: ZodSchema;
  oobCode: string;
  onError?: () => void;
};

export function useResetPasswordMutation({
  onSuccess,
  schema,
  oobCode,
  onError,
}: Args) {
  return useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      return await confirmPasswordReset(oobCode, data.password, onError);
    },
    onError: (error: Error) => {
      throw new Error(formatFirebaseError(error.message));
    },
    onSuccess: (data) => {
      // submit callback
      onSuccess?.(data);
    },
  });
}

export default useResetPasswordMutation;
